import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from 'reactstrap';
import { Controller, useForm } from 'react-hook-form';
import { ReviewForm } from '../models/kycModel';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

interface CustomerReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: ReviewForm) => void;
}

const CustomerReviewModal: React.FC<CustomerReviewModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm<ReviewForm>({
    resolver: yupResolver(
      yup
        .object({
          comment: yup.string().required('Documento es requerido.'),
        })
        .required(),
    ),
  });

  const closeModal = () => {
    onClose();
    reset(); // Reset the form when closing the modal
  };
  return (
    <Modal isOpen={isOpen} toggle={closeModal} centered>
      <ModalHeader toggle={closeModal}>Revisión del cliente</ModalHeader>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody>
          <div className="mb-3" style={{ fontSize: '0.98rem', color: '#555' }}>
            <strong>Importante:</strong> Al enviar este comentario:
            <ul style={{ marginBottom: 0 }}>
              <li>El formulario volverá a estado editable para el cliente.</li>
              <li>
                El cliente será notificado por correo electrónico con el
                comentario que escribas a continuación.
                <br />
                <span className="text-danger">
                  Por favor, sé claro y respetuoso en tu observación.
                </span>
              </li>
            </ul>
          </div>
          <FormGroup>
            <Label for="comment">
              Comentario <span style={{ color: 'red' }}>*</span>
            </Label>
            <Controller
              name="comment"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  type="textarea"
                  style={{ resize: 'none' }}
                  id="comment"
                  invalid={!!errors.comment}
                />
              )}
            />
            {errors.comment && (
              <FormFeedback>{errors.comment.message}</FormFeedback>
            )}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeModal} type="button">
            Cerrar
          </Button>
          <Button color="danger" type="submit">
            Enviar comentario
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default CustomerReviewModal;
